import React from 'react';
import { cn } from '@/lib/utils';

type StageState =
  | 'ok' | 'approved' | 'published' | 'live'
  | 'warn' | 'pending' | 'not_generated' | 'draft'
  | 'error' | 'missing' | 'not_found'
  | 'in_feed_scope' | 'retained_published' | 'out_of_scope'
  | string;

interface StagePillProps {
  state: StageState;
  label?: string;
  className?: string;
}

const STATE_STYLES: Record<string, string> = {
  ok:               'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  approved:         'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
  published:        'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-300',
  live:             'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-300',
  in_feed_scope:       'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  retained_published:  'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-300',
  out_of_scope:        'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  // D19: 4-way source values
  feed_and_manifest:   'bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-300',
  feed_only:           'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  manifest_only:       'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
  not_in_aeo:          'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-500',
  warn:             'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  pending:          'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300',
  draft:            'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  not_generated:    'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400',
  error:            'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  missing:          'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  not_found:        'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
};

const STATE_LABELS: Record<string, string> = {
  ok:               'OK',
  approved:         'Approved',
  published:        'Published',
  live:             'Live',
  in_feed_scope:    'In feed',
  retained_published:'Retained',
  out_of_scope:     'Out of scope',
  warn:             'Warning',
  pending:          'Pending',
  draft:            'Draft',
  not_generated:    'Not generated',
  error:            'Error',
  missing:          'Missing',
  not_found:        'Not found',
};

export function StagePill({ state, label, className }: StagePillProps) {
  const style = STATE_STYLES[state] ?? 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400';
  const text  = label ?? STATE_LABELS[state] ?? state;

  return (
    <span className={cn('inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap', style, className)}>
      {text}
    </span>
  );
}
